export enum WarehousingAbnormalType {
  RemainingSku = 'RemainingSku',
  RfCheckedNoAd = 'RfCheckedNoAd'
}
